


function Home() {
  return (
    <div className="home">
      <div className=""> 
        <div className="text-center">

          <img src="https://i.imgur.com/NDdG8BY.png" className="hp-logo" alt="placebookmain-blk"/>
          <h5 className="home-subtitle">travel, capture, share</h5>
          <p className="project-text">General Assembly SEI 60</p> 
          <p className="project-text">by Duncan Browne, Mike Salter, Alex Chan 2022</p>


        </div>
      </div>
    </div>
  )
}
export default Home